export const AWARD_LABELS = {
  qb_of_week: 'QB of the Week',
  most_efficient: 'Most Efficient',
  biggest_riser: 'Biggest Riser',
  dual_threat: 'Dual Threat',
  deep_ball: 'Deep Ball Leader'
};

export const AWARD_KEYS = Object.keys(AWARD_LABELS);

// QB system admin password (same as the existing QB Club Manager)
export const QB_ADMIN_PASSWORD = 'Braxton2017!';
